import { useMemo } from 'react'
import { jornada } from 'service/api'
import { useStore } from 'store'
import { diarioColumns, mensalColumns } from '../columns'
import LocaisToolbar from '../toolbar/locais-toolbar'
import { DigitacaoSubPages } from './DigitacaoSubPages'
import { useDigitacaoContext } from './useDigitacaoContext'

export default function DigitacaoLocaisPage() {
    const {
        view,
        periodo: [dataInicial, dataFinal],
    } = useDigitacaoContext()
    const funcionarioId = useStore(state => state.employeeId)
    const empresaId = useStore(state => state.companyId)
    const localId = useStore(state => state.locationId)
    const empresa = useStore(state => state.company)

    const {
        data: mensal,
        isLoading: isLoadingMensal,
        error: mensalError,
    } = jornada.mensal.useFetch({
        queryParams: {
            dataInicial,
            dataFinal,
            funcionarioId,
        },
        enabled: localId != -1 && funcionarioId > 0 && view === 'mensal',
    })

    const {
        data: diario,
        isLoading: isLoadingDiario,
        error: diarioError,
    } = jornada.diaria.useFetch({
        queryParams: {
            dia: dataInicial,
            empresaId,
            localId: localId === -1 ? undefined : localId,
        },
        enabled: localId != -1 && funcionarioId > 0 && view === 'diario',
    })

    const columns = useMemo(() => {
        return view === 'mensal'
            ? mensalColumns(empresa?.exibirSaldoDiario == 'S')
            : diarioColumns
    }, [view, empresa?.exibirSaldoDiario])

    const errorMensal = (() => {
            if (mensalError) return mensalError
            if (localId === -1) return { message: 'Local não selecionado' }
        })(),
        errorDiario = (() => {
            if (diarioError) return diarioError
            if (localId === -1) return { message: 'Local não selecionado' }
        })()

    return (
        <DigitacaoSubPages
            Toolbar={LocaisToolbar}
            columns={columns}
            dataDiario={diario}
            dataMensal={mensal}
            diarioError={errorDiario}
            mensalError={errorMensal}
            isErrorDiario={!!errorDiario}
            isErrorMensal={!!errorMensal}
            isLoadingDiario={isLoadingDiario}
            isLoadingMensal={isLoadingMensal}
        />
    )
}
